// @ts-nocheck
/**
 * mediaUploadHandlers.ts
 * 写真アップロード・削除関連メソッド
 * App.vue から切り出し
 */

import store from '@/store'
import {
  featureCollectionAdd,
  updateSingleMarker,
  showSuccess,
} from '@/js/downLoad'
import { closeAllPopups } from '@/js/popup'
import {
  geojsonUpdate,
} from '@/js/pyramid'
import {
  clickCircleSource,
} from '@/js/layers'
import {
  isImageFile,
  isPdfFile,
  compressImageToUnder10MB,
  bakeRotationToBlob,
} from '@/js/downLoad'
import { appendIdToken } from '@/js/utils/firebaseAuth'
import { consumeToken } from '@/js/tokenService'

type VM = any

export async function savePicture(vm: VM) {
  // トークン消費（2pt）
  const tokenResult = await consumeToken('draw_photo_upload')
  if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') {
    return
  }

  store.state.loading2 = true
  store.state.loadingMessage = '保存中です。'
  if (vm.isNewPicture) {
    let file = Array.isArray(vm.s_selectedFile)
        ? (vm.s_selectedFile[0] || null)
        : vm.s_selectedFile
    if (!file) {
      alert("写真を選択してください");
      return;
    }
    const maxSize = 1 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      vm.isDisabled = true
      store.state.loadingMessage = '<span style="color: red;">1mbを超えています。</span><br>圧縮しますので時間がかかります。'
    }

    if (isPdfFile(file.name)) {
      // PDFは圧縮・回転不要 — そのままアップロード
    } else if (isImageFile(file.name)) {
      // 画像サイズチェック
      if (file.size > maxSize) {
        // 10MB超え → 圧縮処理
        try {
          const blob = await compressImageToUnder10MB(file, file.type === 'image/png' ? 'image/png' : 'image/jpeg');
          if (blob.size > 1 * 1024 * 1024) {
            alert("10MB以下に圧縮できませんでした");
            return;
          }
          file = new File([blob], file.name, { type: blob.type });
        } catch (err) {
          console.error("圧縮失敗:", err);
          alert("画像圧縮中にエラーが発生しました");
          return
        }
      }
      if (vm.imgRotation !== 0) {
        const blob = await bakeRotationToBlob(file, vm.imgRotation)
        const name = file.name
        file = new File([blob], name, { type: blob.type })
      }
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("dir", vm.$store.state.userId || '0000notLoggedIn');
    await appendIdToken(formData)
    try {
      const response = await fetch("https://kenzkenz.net/myphp/upload_picture.php", {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (result.success) {
        vm.s_pictureUrl = result.webUrl
        vm.drawGeojsonAddPicture()
        closeAllPopups()
        if (!vm.$store.state.isUsingServerGeojson) {
          featureCollectionAdd()
        }
        // alert("更新成功。");
      } else {
        vm.s_pictureUrl = null
        alert("更新失敗: " + result.message);
      }
    } catch (error) {
      console.error("更新エラー:", error);
      vm.s_pictureUrl = null
      alert("通信エラー");
    }
    vm.s_dialogForPicture = false
  } else {
    if (vm.imgRotation !== 0) {
      let file
      const response = await fetch(vm.s_pictureUrl);
      let blob = await response.blob();
      file = new File([blob], vm.s_pictureUrl, {type: blob.type});
      blob = await bakeRotationToBlob(file, vm.imgRotation)
      const name = file.name
      file = new File([blob], name, {type: blob.type})
      const formData = new FormData();
      formData.append("file", file);
      formData.append("dir", vm.$store.state.userId || '0000notLoggedIn');
      await appendIdToken(formData)
      try {
        const response = await fetch("https://kenzkenz.net/myphp/upload_picture.php", {
          method: "POST",
          body: formData,
        });
        const result = await response.json();
        if (result.success) {
          vm.s_pictureUrl = result.webUrl
          vm.drawGeojsonAddPicture()
          closeAllPopups()
          if (!vm.$store.state.isUsingServerGeojson) {
            featureCollectionAdd()
          }
          vm.s_previewUrl = result.webUrl
          // alert("更新成功。");
        } else {
          vm.s_pictureUrl = null
          alert("更新失敗: " + result.message);
        }
      } catch (error) {
        console.error("更新エラー:", error);
        vm.s_pictureUrl = null
        alert("通信エラー");
      }
    } else {
      vm.s_pictureUrl = null
      vm.drawGeojsonAddPicture()
    }
    vm.s_dialogForPicture = false
    setTimeout(() => {
      vm.imgRotation = 0
    },100)
  }
  // 該当マーカーのみ更新（全体再描画せずフリッカー防止）
  updateSingleMarker(vm.$store.state.drawGeojsonId)
  store.state.loading2 = false
  vm.isDisabled = false
}
export async function deletePicture(vm: VM) {
  if (!vm.s_pictureUrl) return
  if (!vm.s_pictureUrl.includes(vm.$store.state.userId)) {
    alert('他の人がアップした写真なので削除できません')
    return
  }
  if (!confirm("削除しますか？")) {
    return
  }
  const serverUrl = vm.s_pictureUrl.replace('https://kenzkenz.net/','/var/www/html/public_html/')
  const formData = new FormData();
  formData.append("serverUrl", serverUrl);
  await appendIdToken(formData)
  const response = await fetch("https://kenzkenz.net/myphp/unlink_picture.php", {
    method: "POST",
    body: formData
  });
  const result = await response.json();
  if (result.success) {
    vm.s_previewUrl = ''
    vm.s_pictureUrl = ''
    const map01 = vm.$store.state.map01
    const id = vm.$store.state.drawGeojsonId
    const tgtProp = 'pictureUrl'
    const value = {pictureUrl: 'delete'}
    vm.$store.state.clickCircleGeojsonText = geojsonUpdate(map01,null,clickCircleSource.iD,id,tgtProp,value)
    closeAllPopups()
    vm.s_selectedFile = null

    // markaersRemove()
    // vm.savePicture()

    showSuccess("削除成功！");
  } else {
    alert("削除失敗！: " + result.message);
  }
}
export function onFileSelected(vm: VM) {
  const file = Array.isArray(vm.s_selectedFile)
      ? (vm.s_selectedFile[0] || null)
      : vm.s_selectedFile
  if (file) {
    // 古いURLを解放（メモリリーク防止）
    if (vm.s_previewUrl) {
      URL.revokeObjectURL(vm.s_previewUrl);
      vm.s_previewUrl = null
    }
    setTimeout(() => {
      vm.s_previewUrl = URL.createObjectURL(file);
    },0)
    vm.isNewPicture = true
  } else {
    vm.s_previewUrl = null
  }
}